export const FRONT_BASE_URL = process.env.REACT_APP_FRONT_BASE_URL

export function isNullOrUndefined(arg: any) {
  return arg == null
}